import { stepConnectorClasses } from '@mui/material/StepConnector';
import { stepIconClasses } from '@mui/material/StepIcon';
import { stepLabelClasses } from '@mui/material/StepLabel';
import type { Components } from '@mui/material/styles';

import type { Theme } from '../theme/types';

export const MuiStepper = {
  styleOverrides: {
    root: {
      // Base stepper container styles
    },
  },
} satisfies Components<Theme>['MuiStepper'];

export const MuiStep = {
  styleOverrides: {
    root: {
      // MuiStep uses MUI defaults with no custom styling required
      // Step container only provides layout structure
      // All visual styling is handled by MuiStepConnector, MuiStepLabel, and MuiStepIcon
    },
  },
} satisfies Components<Theme>['MuiStep'];

export const MuiStepConnector = {
  styleOverrides: {
    root: {
      // Active connector styling
      [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
          borderColor: 'var(--mui-palette-primary-main)',
        },
      },
      // Completed connector styling with gradient
      [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
          background:
            'linear-gradient(90deg, var(--mui-palette-primary-main), var(--mui-palette-primary-dark))',
          borderColor: 'transparent',
        },
      },
    },
    horizontal: {
      // Horizontal connector specific styles (default)
    },
    vertical: {
      // Vertical connector specific styles
      marginLeft: 16, // Half of icon size (32px / 2)
    },
    line: ({ theme }) => ({
      borderTopWidth: 2,
      borderRadius: 1,
      borderColor:
        theme.palette.mode === 'dark'
          ? 'rgba(255, 255, 255, 0.12)'
          : 'rgba(0, 0, 0, 0.12)',
    }),
    lineHorizontal: {
      borderTopWidth: 2,
    },
    lineVertical: {
      borderLeftWidth: 2,
      minHeight: 24,
    },
  },
} satisfies Components<Theme>['MuiStepConnector'];

export const MuiStepLabel = {
  styleOverrides: {
    root: {
      // Root label container
    },
    label: {
      fontSize: '0.875rem', // body2 typography
      lineHeight: 1.43, // body2 typography
      color: 'var(--mui-palette-text-secondary)',
      // Active label styling
      [`&.${stepLabelClasses.active}`]: {
        color: 'var(--mui-palette-text-primary)',
        fontWeight: 600,
      },
      // Completed label styling
      [`&.${stepLabelClasses.completed}`]: {
        color: 'var(--mui-palette-primary-main)',
        fontWeight: 500,
      },
    },
    iconContainer: {
      // Icon container padding
      paddingRight: 12,
    },
  },
} satisfies Components<Theme>['MuiStepLabel'];

export const MuiStepIcon = {
  styleOverrides: {
    root: ({ theme }) => ({
      width: 32,
      height: 32,
      color:
        theme.palette.mode === 'dark'
          ? 'rgba(255, 255, 255, 0.12)'
          : 'rgba(0, 0, 0, 0.12)',
      // Active icon styling
      [`&.${stepIconClasses.active}`]: {
        color: 'var(--mui-palette-primary-main)',
      },
      // Completed icon styling
      [`&.${stepIconClasses.completed}`]: {
        color: 'var(--mui-palette-primary-main)',
      },
    }),
    text: {
      fontWeight: 600,
      fontSize: '0.875rem',
    },
  },
} satisfies Components<Theme>['MuiStepIcon'];
